'use strict';

import React, { Component } from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout from '@Layout/ECFront'

import UpdateForm from '@/Form/UpdateForm'

import _config from '@Config/EC/EC'

import Link from '@Pure/Link'

import _ from 'lodash'

const app = window.app;

export default class ECInfosPage extends Component
{
	state = { };

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange('ECInfosPage');
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange();
	}

	handleSessionChange = (source) =>
	{
		const component = this, props = this.props, state = this.state;

		if (app.state.session.EC instanceof Object === false) return;

		component.setState(
		{
			EC: _.cloneDeep(app.state.session.EC)
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let config = _.cloneDeep(_config);

		config.can_delete = false;

		config.form_title = 'Informations';

		let allowed_fields =
		[
			'address[line_1]',
			'address[line_2]',
			'address[zip_code]',
			'address[city]',
			'phone',
			'email',
			'opening_time',
			'description',
			'logo',
			'pdfs'
		];

		config.fields['description'].label += ' visible par les membres ' +
			'dans « Infos pratiques »';

		Object.keys(config.fields).forEach(function (field)
		{
			if (allowed_fields.includes(field) !== true)
			{
				delete config.fields[field];
			}
		});

		config.collapses.forEach(function (collapse)
		{
			collapse.elements = collapse.elements.filter(function (name)
			{
				if (typeof name !== 'string') return false;

				return allowed_fields.includes(name);
			});
		});

		config.collapses = config.collapses.filter(function (collapse)
		{
			return collapse.elements.length > 0;
		});

		let form;

		if (state.EC instanceof Object)
		{
			form =
			(
				<TransitionGroup className="page-form-container">

					<CSSTransition
						classNames="a-form-transition"
						appear={ true }
						enter={ true }
						exit={ true }
						timeout={{ enter: 240, exit: 320, appear: 500 }}>

						<UpdateForm config={ config } id={ state.EC.id }
							className="u-no-margin-top"
						/>

					</CSSTransition>

				</TransitionGroup>
			);
		}

		var output =
		(
			<Layout page_title="Modification des informations"
				history={ props.history }>

				<div className="page-content">

					<div className="o-content">

						{ form }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}